module.exports = __webpack_public_path__ + "static/media/prediction.853b31da.gif";